import { render, staticRenderFns } from "./ideaSettingModal.vue?vue&type=template&id=335459b6&scoped=true"
import script from "./ideaSettingModal.vue?vue&type=script&lang=js"
export * from "./ideaSettingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335459b6",
  null
  
)

export default component.exports